import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right\">\n<path d=\"M7.326 3.20088C7.19721 3.34434 7.13281 3.50201 7.13281 3.67388C7.13281 3.84576 7.19721 3.99609 7.326 4.12488L14.0291 10.9999L7.326 17.8749C7.19721 18.0037 7.13281 18.154 7.13281 18.3259C7.13281 18.4978 7.19721 18.6481 7.326 18.7769C7.45479 18.9057 7.60513 18.9701 7.777 18.9701C7.94888 18.9701 8.09921 18.9128 8.228 18.7982L15.3395 11.4722C15.4683 11.3434 15.5327 11.1857 15.5327 10.9992C15.5327 10.8127 15.4683 10.655 15.3395 10.5262L8.228 3.2002C8.09921 3.08561 7.94888 3.02832 7.777 3.02832C7.60513 3.02832 7.45479 3.08561 7.326 3.2002V3.20088Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-right.svg
// module id = RMf8
// module chunks = 258